import React, { Component } from "react";
import "./ConfirmShipToModal.scss";
import IUpdateOrderEntryDetailDTO from "../../../models/DTO/IUpdateOrderEntryDetailDTO";
import IAddress from "../../../models/IAddress";
import IOrder from "../../../models/IOrder";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import AddressBlock from "../../shared/AddressBlock/AddressBlock";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import OwButton from "../../shared/OwButton/OwButton";
import OwGoogleStaticMap from "../../shared/OwGoogleStaticMap/OwGoogleStaticMap";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import EndpointsEnum from "../../../models/EndpointsEnum";

type Props = {
    order: IOrder;
    cancelFn: () => void;
    confirmFn: () => void;
    socket: Socket;
    supplierModel: ISupplierModel;
    userModel: IUserUI;
};

type State = {
    editMode: boolean;
    address: IAddress;
    completeBtnActive: boolean;
};

class ConfirmShipToModal extends Component<Props, State> {
    sockets: IUiSocketSetup[] = [];

    readonly state: State = {
        editMode: false,
        address: this.props.order.Ship_To!,
        completeBtnActive: false,
    };

    constructor(props: Props) {
        super(props);

        this.sockets = [{ endpoint: EndpointsEnum.OrderEntryOnUpdateOrderEntryDetail, fn: this.onUpdateOrderEntryDetail }];
    }

    componentDidMount() {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }
    }

    componentWillUnmount() {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }
    }

    toggleEditMode = () => {
        this.setState({
            editMode: !this.state.editMode,
        });
    };

    saveAndConfirm = () => {
        this.props.confirmFn();
    };

    cancel = () => {
        this.props.cancelFn();
    };

    onUpdateOrderEntryDetail = () => {
        this.setState({
            completeBtnActive: false,
            editMode: false,
        });
    };

    saveAddress = (e: any) => {
        const value = e.target.value;
        const name = e.target.name;

        const address = this.state.address;

        // @ts-expect-error
        address[name] = value;

        this.setState({
            address,
        });
    };

    completeEdit = () => {
        this.updateOrderEntryDetail();
    };

    updateOrderEntryDetail = () => {
        const payload: Partial<IUpdateOrderEntryDetailDTO> = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            vendorGuid: this.props.order.Vendor!.guid,
            orderGuid: this.props.order.guid,
            supplierGuid: this.props.supplierModel.guid,
            Ship_To: this.state.address,
        };

        this.props.socket.emit("updateOrderEntryDetail", payload);

        this.setState({
            completeBtnActive: true,
        });
    };

    render() {
        return (
            <div className="ConfirmShipToModal">
                <OwTitle title={"confirm_ship_to"} tag={"h3"} />

                {!this.state.editMode ? (
                    <div>
                        <div className={"d-flex"}>
                            {this.props.supplierModel.has_google_maps ? (
                                <OwGoogleStaticMap className={"me-2"} address={this.state.address} size={"120x120"} />
                            ) : null}
                            <AddressDisplay address={this.state.address} showCompanyName={true} showName={true} />
                        </div>

                        <div>
                            <OwLabel title={"edit_address"} leftIconClass={"fad fa-pencil"} fn={this.toggleEditMode} />
                        </div>
                    </div>
                ) : null}

                {this.state.editMode ? (
                    <div>
                        <AddressBlock address={this.state.address} fn={this.saveAddress} showName={true} showCompanyName={true} />

                        <div className={"mt-3"}>
                            <OwButton
                                active={this.state.completeBtnActive}
                                disableOnActive={true}
                                title={"finish_edit"}
                                leftIconClass={"fas fa-check"}
                                fn={this.completeEdit}
                            />
                            <OwButton
                                className={"btn-danger ms-2"}
                                title={"cancel_edit"}
                                leftIconClass={"fas fa-times"}
                                fn={this.toggleEditMode}
                            />
                        </div>
                    </div>
                ) : null}

                {!this.state.editMode ? (
                    <div>
                        <OwButton title={"save"} fn={this.saveAndConfirm} />
                    </div>
                ) : null}
            </div>
        );
    }
}

export default ConfirmShipToModal;
